export default "__VITE_ASSET__p67fOZqH__"